<template>
  <div class="Plan">
    <!-- 底图 -->
    <div class="bg-container">
      <img src="../../static/images/Plan/bg.jpg" alt="" class="bgimg" />
    </div>

    <!-- 导航按钮 -->
    <div class="nav">
      <div
        class="nav-item"
        v-for="(item, index) in navlist"
        :key="index"
        @click="switchNav(index)"
      >
        <img
          :src="activeIndex === index ? item.active : item.normal"
          alt=""
          class="nav-img"
        />
      </div>
    </div>

    <!-- 固定底图 -->
    <div class="base-layer">
      <img src="../../static/images/Plan/底图.png" alt="" class="base-img" />
    </div>

    <!-- Swiper 内容区域 -->
    <div class="swiper-container PlanSwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in contentList" :key="index">
          <div class="content-item">
            <img 
              :src="item.img" 
              alt="" 
              class="main-img"
              :class="{ 'animate-in': activeIndex === index && shouldAnimate }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper'

export default {
  data() {
    return {
      activeIndex: 0,
      swiper: null,
      shouldAnimate: true,
      
      // 导航配置
      navlist: [
        {
          normal: './static/images/Plan/总平面图_n.png',
          active: './static/images/Plan/总平面图_h.png'
        },
        {
          normal: './static/images/Plan/流线分析_n.png',
          active: './static/images/Plan/流线分析_h.png'
        },
        {
          normal: './static/images/Plan/景观亮点_n.png',
          active: './static/images/Plan/景观亮点_h.png'
        }
      ],
      
      // 内容配置
      contentList: [
        {
          img: './static/images/Plan/01总平面图.png'
        },
        {
          img: './static/images/Plan/02流线分析.png'
        },
        {
          img: './static/images/Plan/03景观亮点.png'
        }
      ]
    }
  },
  
  mounted() {
    this.initSwiper()
  },
  
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy()
    }
  },
  
  methods: {
    // 初始化 Swiper
    initSwiper() {
      const _that = this
      this.$nextTick(() => {
        this.swiper = new Swiper('.PlanSwiper', {
          initialSlide: 0,
          speed: 600,
          effect: 'slide',
          
          on: {
            slideChangeTransitionStart: function () {
              _that.triggerAnimation(this.activeIndex)
            }
          }
        })
      })
    },
    
    // 触发动画
    triggerAnimation(index) {
      this.shouldAnimate = false
      this.activeIndex = index
      
      // 增加延迟确保动画能正确重新触发
      setTimeout(() => {
        this.shouldAnimate = true
      }, 200)
    },
    
    // 点击导航切换
    switchNav(index) {
      if (this.swiper) {
        this.swiper.slideTo(index, 600, true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.Plan {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #000;

  // 背景图层
  .bg-container {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;

    .bgimg {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  // 固定底图层
  .base-layer {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;

    .base-img {
      width: 100%;
      height: auto;
    //   max-width: 95vw;
      object-fit: contain;
    }
  }

  // 导航按钮
  .nav {
    position: absolute;
    width: 80%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    z-index: 100;
    margin-top: 60vw;
    justify-content: space-between;
    
    .nav-item {
      cursor: pointer;
      transition: all 0.3s ease;
      width: 22vw;
      
      .nav-img {
        width: 100%;
      }
      
      &:hover {
        transform: scale(1.05);
      }
    }
  }

  // Swiper 容器
  .PlanSwiper {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 10;

    .swiper-wrapper {
      transition-timing-function: ease-out;
      
      .swiper-slide {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        
        opacity: 0;
        transition: opacity 0.6s ease;
        
        &.swiper-slide-active {
          opacity: 1;
        }
        
        .content-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100vh;
          
          .main-img {
            width: 100%;
            height: auto;
            // max-width: 95vw;
            object-fit: contain;
            
            &.animate-in {
              animation: scaleIn 1.2s cubic-bezier(0.34, 1.56, 0.64, 1);
            }
            &.animate-in2 {
              animation: scaleIn 2.8s ease;
            }
          }
        }
      }
    }
  }
}

// 动画定义
@keyframes scaleIn {
  0% {
    opacity: 0;
    transform: scale(0.85);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Plan.vue